// @flow
import React from 'react'
import type { Node } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import ErrorText from '../controls/ErrorText'

type Props = {|
  label: Node,
  errors?: Array<string>,
  twoLines?: boolean,
  children: Node,
  className?: string,
  hideLabel?: boolean,
  bottomPadding?: number
|}

const Wrapper: StyledComponent<
  {| bottomPadding?: number, children: any, className?: string |},
  {||},
  any
> = styled.div`
  padding-bottom: ${({ bottomPadding }) => bottomPadding || 20}px;
`

const Line: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  font-size: 14px;
`

const Label: StyledComponent<{| twoLines?: boolean, children?: any |}, {||}, any> = styled.div`
  width: 90px;
  margin-right: 10px;
  vertical-align: top;
  padding: 0;
  padding-top: ${({ twoLines }) => (twoLines ? '3px' : '10px')};
`

const WidgetWrapper: StyledComponent<Object, any, any> = styled.div`
  width: 100%;
`

export default function LabeledWrapper({
  label,
  errors,
  children,
  twoLines,
  className,
  hideLabel,
  bottomPadding
}: Props) {
  return (
    <Wrapper className={className} bottomPadding={bottomPadding}>
      <Line>
        {!hideLabel && <Label twoLines={twoLines}>{label}</Label>}
        <WidgetWrapper>{children}</WidgetWrapper>
      </Line>
      <ErrorText errors={errors} marginLeft />
    </Wrapper>
  )
}
